export const Home_Screen = "/";
export const ContactUs_Screen = "Contact-us";
export const Tech_Screen = "/tech-stack";
export const AboutUs_Screen = "/about-us";
export const Blog_Screen = "/blog";
export const Blog_Detail_Screen = "/blog-detail";
